export const ADD_ANSWER = 'ADD_ANSWER'
export const ADD_CHUNK = 'ADD_CHUNK'
export const ADD_COMMENT = 'ADD_COMMENT'
export const ADD_RECOMMENDATION = 'ADD_RECOMMENDATION'
export const ADD_SUGGESTION = 'ADD_SUGGESTION'
export const DELETE_CHUNK = 'DELETE_CHUNK'
export const EMPTY_SIMPLE_QUESTIONS = 'EMPTY_SIMPLE_QUESTIONS'
export const GET_CHILDREN = 'GET_CHILDREN'
export const GET_PROBLEMS = 'GET_PROBLEMS'
export const GET_RECOMMENDATIONS = 'GET_RECOMMENDATIONS'
export const GET_SUGGESTIONS = 'GET_SUGGESTIONS'
export const REMOVE_ANSWER = 'REMOVE_ANSWER'
export const SET_CHUNK = 'SET_CHUNK'
export const SET_CHUNK_CROWD_RATING = 'SET_CHUNK_CROWD_RATING'
export const SET_CHUNK_DUEDATE = 'SET_CHUNK_DUEDATE'
export const SET_CHUNK_LAST_EDITED = 'SET_CHUNK_LAST_EDITED'
export const SET_CHUNK_STARTDATE = 'SET_CHUNK_STARTDATE'
export const SET_CHUNK_STATE = 'SET_CHUNK_STATE'
export const SET_CURRENT_ANSWERS = 'SET_CURRENT_ANSWERS'
export const SET_CURRENT_QUESTION_ROOT = 'SET_CURRENT_QUESTION_ROOT'
export const SET_PROBLEM_LABEL = 'SET_PROBLEM_LABEL'
export const SET_REPORT_ANSWERS = 'SET_REPORT_ANSWERS'
export const SET_REPORT_STATUS = 'SET_REPORT_STATUS'
export const UPDATE_ARG_GRAPH = 'UPDATE_ARG_GRAPH'
export const UPDATE_CHILDREN = 'UPDATE_CHILDREN'
export const UPDATE_SCORES = 'UPDATE_SCORES'
export const UPDATE_SIMPLE_QUESTIONS = 'UPDATE_SIMPLE_QUESTIONS'
export const UPDATE_TEXT = 'UPDATE_TEXT'
